import serialize from 'form-serialize';

export default function jsonFormData (form) {
  return serialize(form, {
    hash: true,
    disabled: true,
  });
}
